import httpClient from '@/services/http/httpClient'
import serializeObject from '@/utils/serializeObject'

export const apiGetMenus = (FNOLTabsParams) => {
  return httpClient
    .get('menus/', {
      params: FNOLTabsParams
    })
    .then((data) => data)
    .catch((error) => Promise.reject(error))
}

export const apiGetForm = (formParams, warrantyId) => {
  const parsedParams =
    (Object.keys(formParams).length > 0 ? '?' : '') +
    serializeObject(formParams)
  return httpClient
    .get(`forms/${warrantyId}/${parsedParams}`)
    .then((data) => data)
    .catch((error) => Promise.reject(error))
}

export const apiGetLevelMobilierCategory = (searchParams) => {
  const parsedParams =
    (Object.keys(searchParams).length > 0 ? '?' : '') +
    serializeObject(searchParams)
  return httpClient
    .get(`/forms/lastlevel/${parsedParams}`)
    .then((data) => data)
    .catch((error) => Promise.reject(error))
}

export const apiSearchMobilier = (warrantyId, searchParams) => {
  const parsedParams =
    (Object.keys(searchParams).length > 0 ? '?' : '') +
    serializeObject(searchParams)
  return httpClient
    .get(`assets/browser/${warrantyId}${parsedParams}`)
    .then((data) => data)
    .catch((error) => Promise.reject(error))
}

export const apiSearchMobilierUptec = (searchParams) => {
  const parsedParams =
    (Object.keys(searchParams).length > 0 ? '?' : '') +
    serializeObject(searchParams)
  return httpClient
    .get(`furniture/upptec/search${parsedParams}`)
    .then((data) => data)
    .catch((error) => Promise.reject(error))
}

export const apiSearchPredictibles = (warrantyId) => {
  return httpClient
    .get(`/assets/browser/shortcuts/${warrantyId}`)
    .then((data) => data)
    .catch((error) => Promise.reject(error))
}
